import { Box, Button, Flex, HStack, Img, keyframes, Link, Stack, Text } from '@chakra-ui/react'
import ArrowRightOmens from 'components/svg/ArrowRightOmens'
import { Body1, H1 } from 'components/typography'
import { ONBOARDING_INITIAL_STEP } from 'constants/onboarding'
import { FC } from 'react'

interface Props {
  gads: boolean
}

const onlinePulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
  70% { box-shadow: 0 0 0 8px rgba(34, 197, 94, 0); }
`

const arrowNudge = keyframes`
  0%, 60%, 100% { transform: translateX(0); }
  20% { transform: translateX(8px); }
  40% { transform: translateX(0); }
`

const MedleveHeroMobile: FC<Props> = ({ gads }) => {
  return (
    <Box position="relative" minH={{ base: 'calc(100vh - 64px)', md: '720px' }} w="full" overflow="hidden">
      <Img
        src="/landings/doctor-using-smarphone.webp"
        alt=""
        aria-hidden
        objectFit="cover"
        objectPosition="50% 25%"
        position="absolute"
        inset={0}
        w="full"
        h="full"
      />
      <Box
        position="absolute"
        inset={0}
        bg="linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.65) 50%, rgba(0,0,0,0.92) 100%)"
      />

      <Flex position="absolute" inset={0} direction="column" px="20px" pt="96px" pb="28px" color="alabaster" zIndex={2}>
        <Stack spacing={6} my="auto" py={8}>
          <Flex
            align="center"
            gap={2}
            alignSelf="flex-start"
            px={3}
            py="6px"
            borderRadius="full"
            bg="rgba(0,0,0,0.55)"
            border="1px solid rgba(255,255,255,0.18)"
            backdropFilter="blur(8px)"
          >
            <Box
              w="8px"
              h="8px"
              borderRadius="full"
              bg="#22C55E"
              animation={`${onlinePulse} 1.8s ease-in-out infinite`}
            />
            <Text fontSize="13px" fontWeight={600} letterSpacing="-0.01em">
              Médicos online agora
            </Text>
          </Flex>
          <H1 fontSize={{ base: '30px', sm: '34px' }} fontWeight={800} letterSpacing="-0.02em" lineHeight="1.1">
            {gads
              ? 'Comece seu tratamento com acompanhamento médico online'
              : 'Caneta de emagrecimento com prescrição* médica'}
          </H1>
          <Box color="#b8d4ff" fontWeight={800} fontSize="18px" lineHeight="1.3">
            Perder peso custa menos do que você imagina!
          </Box>
          <Body1 fontSize="17px" fontWeight={400} lineHeight="1.5" opacity={0.95}>
            {gads
              ? 'Receba orientação médica especializada e descubra o tratamento ideal para você, com segurança e praticidade.'
              : 'Orientação médica especializada e medicamento entregue na sua casa.'}
          </Body1>

          <Link href={`/onboarding/weight_loss/${ONBOARDING_INITIAL_STEP}`} _hover={{ textDecoration: 'none' }} pt={3}>
            <Button
              w="full"
              h="auto"
              px="22px"
              py="20px"
              borderRadius="22px"
              bg="#4774B8"
              color="alabaster"
              boxShadow="0 10px 28px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.08), inset 0 1px 0 rgba(255,255,255,0.22)"
              _hover={{ bg: '#5A8AD4' }}
            >
              <Flex w="full" justify="space-between" align="center">
                <Body1
                  fontWeight={800}
                  fontSize="17px"
                  sx={{ fontFeatureSettings: "'ss01' on, 'liga' off, 'calt' off" }}
                  letterSpacing="-0.01em"
                  lineHeight="1.4rem"
                >
                  Começar agora
                </Body1>
                <ArrowRightOmens
                  fill="alabaster"
                  boxSize="18px"
                  sx={{ animation: `${arrowNudge} 2.2s ease-in-out infinite` }}
                />
              </Flex>
            </Button>
          </Link>
        </Stack>

        <HStack justify="space-around" align="center">
          <Img src="/landings/Anvisa-light.png" alt="Anvisa" h="88px" w="auto" objectFit="contain" />
          <Img src="/landings/SSL.png" alt="SSL" h="88px" w="auto" objectFit="contain" />
          <Img src="/landings/LGPD-light.png" alt="LGPD" h="88px" w="auto" objectFit="contain" />
        </HStack>
      </Flex>
    </Box>
  )
}

export default MedleveHeroMobile
